<script setup lang="ts">
import { MMText, useMedia } from '@mm-frontend/mm-web-ui-kit';
import { ButtonPrimaryAccented } from '~/features/ui-kit';
import { DateFormatter } from '#shared/helpers';

const props = defineProps<{ nearestDelivery?: string; availableAmount?: number }>();

const isDisabled = computed(() => {
  if (typeof props.availableAmount === 'undefined') return false;
  return !props.availableAmount;
});

const { isMobileOrTablet } = useMedia();

const nearestDeliveryDateFormatted = computed(() => {
  if (!props.nearestDelivery) return 'завтра';

  return DateFormatter.relativeFromNow(props.nearestDelivery).value.toLowerCase();
});
</script>

<template>
  <ButtonPrimaryAccented size="xl56" :w100="!isMobileOrTablet" :disabled="isDisabled">
    <MMText v-if="isDisabled" font="Body L/Semibold" color="disabled">Нет в наличии</MMText>

    <div v-else class="button-add-to-cart">
      <MMText font="Body L/Semibold" color="inverse-primary">
        {{ isMobileOrTablet ? 'В корзину' : 'Добавить в корзину' }}
      </MMText>
      <MMText font="Caption M/Regular" color="inverse-primary">
        Доставим {{ nearestDeliveryDateFormatted }}
      </MMText>
    </div>
  </ButtonPrimaryAccented>
</template>

<style scoped lang="stylus">
.button-add-to-cart
  display flex
  flex-direction column
</style>
